import React from 'react';

const Idea = () => {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.2657 36.0699C34.4705 36.0699 41.9323 28.608 41.9323 19.4032C41.9323 10.1985 34.4705 2.73657 25.2657 2.73657C16.0609 2.73657 8.599 10.1985 8.599 19.4032C8.599 28.608 16.0609 36.0699 25.2657 36.0699Z"
        fill="#FFE457"
      />
      <path d="M31.5156 33.9866H19.0156V40.2366H31.5156V33.9866Z" fill="#FFE457" />
      <path
        d="M18.9729 40.2366V46.4866C18.9729 47.0391 19.1924 47.5691 19.5831 47.9597C19.9738 48.3503 20.5037 48.5699 21.0562 48.5699H29.3896C29.9421 48.5699 30.4719 48.3503 30.8627 47.9597C31.2533 47.5691 31.4729 47.0391 31.4729 46.4866V40.2366H18.9729Z"
        fill="#A0A6AB"
      />
    </svg>
  );
};

export default Idea;
